<template>
    <div class="public_container add_approval_wrap" v-loading="loading">
        <div class="returnNavBar">
            <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true">

            </ReturnNavBar>
        </div>
        <div class="mobile_container">
            <CustomFormMobile
                    ref="approval_custom_form"
                    :field_list="formInfoList"
                    @submit-form="submitFormData"
                    v-if="dataLoaded"
            />

            <div class="add_approval_select_process">
                <div class="add_approval_select_process_title"><span>审批流程</span></div>
                <approveProcessSelect ref="approveProcessSelectRef" :approval_node_list="approval_node_list"></approveProcessSelect>
            </div>
        </div>
        <div class="add_footer_wrap">
            <van-button round block type="info" :disabled="btnDisabled" @click="handleClickConfirm">提交</van-button>
        </div>
    </div>
</template>

<script>
import { getFormFields, getApprovalNodes, getFiledKey ,approvalAdd} from "@/api";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import CustomFormMobile from "@/components/mComponents/CustomFormMobile";
import approveProcessSelect from "@/components/mComponents/approveProcessSelect";
export default {
    name: "mobileApproveAdd",
    components: { ReturnNavBar, CustomFormMobile ,approveProcessSelect},
    data() {
        return {
            approvalName:'',
            approvalId:0,
            btnDisabled:false,
            formInfoList:[],
            formData:null,
            loading:false,
            dataLoaded:false,
            approval_node_list:[],//审批流程
            condition_filed_key:[], //作为条件的字段
            isFormCheck:false,//表单校验
        };
    },
    created() {
        this.approvalId = this.$route.query.id
        this.approvalName = this.$route.query.name
        this.getFiledKey()
    },
    methods: {
        // 获取审批的字段
        _getFromFields() {
            this.loading = true
            getFormFields({
                field_form: 'approval_type_' + this.approvalId
            }).then(res => {
                if (res.code === 200) {
                    this.formInfoList = res.data
                    this.dataLoaded = true
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        // 获取作为条件的字段
        getFiledKey(){
            getFiledKey({
                approval_set_id: this.approvalId,
            }).then(res => {
                if (res.code === 200) {
                    this.condition_filed_key = res.data.map(item => {return item.field_key})
                    this.getApprovalNodes() //获取审批流
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        // 获取审批流
        getApprovalNodes(only = false){
            let form_value = JSON.parse(JSON.stringify(this.formData))
            this.approval_node_list = []
            getApprovalNodes({
                approval_set_id: this.approvalId,
                form_value:form_value
            }).then(res => {
                if (res.code === 200) {
                    this.approval_node_list = res.data
                    this.$refs.approveProcessSelectRef.set_approval_node_list(res.data)
                    if(only == false){
                        this._getFromFields() //获取审批字段
                    }
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        handleClickConfirm() {
            this.$refs.approval_custom_form.handleClickPublish();
        },
        // 提交
        submitFormData(customForm) {
            if (customForm) {
                if(this.$refs.approveProcessSelectRef.handleClickPublish() == false){  //审批节点校验没通过
                    return false
                }
                this.btnDisabled = true;
                let data = {
                    approval_set_id:this.approvalId,
                    node_list:this.approval_node_list,
                    form_data:customForm,
                }
                approvalAdd(data).then(res=> {
                    if (res.code === 200) {
                        this.$toast({
                            message: "新增成功",
                            type: "success",
                            duration: 1000,
                            onClose: () => {
                                this.$router.go(-1);
                            },
                        });
                    } else {
                        this.$toast({
                            message: res.message,
                            type: "fail",
                        });
                    }
                });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.add_approval_select_process{
    width: 100%;
    padding: 0 16px;
    background: #fff;
    border-radius: 16px;
    margin-top: 4px;
    box-sizing: border-box;
    .add_approval_select_process_title{
        width: 100%;
        padding: 16px 0;
        box-sizing: border-box;
        span{
            display: block;
            color: rgba(51, 51, 51, 1);
            font-size: 14px;
            line-height: 22px;
            font-weight: 700;
            position: relative;
            padding-left: 12px;
            &:before{
                width: 4px;
                height: 22px;
                left: 0;
                top: 0;
                content: ' ';
                position: absolute;
                background: rgba(41, 144, 255, 1);
                border-radius: 4px;
            }
        }
    }
}
.add_approval_wrap {
    .mobile_container {
        padding: 10px 0;
    }
    .custom_form_wrap{
        height: auto;
    }
    .add_footer_wrap {
        padding: 5px 16px;
        background-color: #f7f8fa;

        .van-button {
            border-radius: 8px;
            height: 38px;
            background-color: rgba(41, 144, 240, 1);
            border-color: rgba(41, 144, 240, 1);
        }
    }
}
</style>
